import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "bi bi-eye" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "bi bi-eye" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_5 = { class: "menu-item-wrapper" }
const _hoisted_6 = { class: "menu-item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)
const _hoisted_8 = { class: "menu-item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-cloud-download-fill" })
], -1)
const _hoisted_10 = { class: "menu-item" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-bug-fill" })
], -1)
const _hoisted_12 = {
  class: "modal fade",
  id: "pop_up_modal",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = { class: "modal-header" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_17 = {
  key: 0,
  class: "modal-body py-10 px-lg-17"
}
const _hoisted_18 = {
  key: 1,
  class: "modal-body py-10 px-lg-17"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode(_component_Table, {
      columns: _ctx.columns,
      rows: _ctx.failed_jobs,
      padding: 5,
      loading: _ctx.loader
    }, {
      "cell-payload": _withCtx(({row:item}) => [
        _createVNode("button", {
          class: "action-btn",
          type: "button",
          onClick: ($event: any) => (_ctx.getScenario(item.payload, 'message.PAYLOAD'))
        }, [
          _hoisted_2
        ], 8, ["onClick"])
      ]),
      "cell-exception": _withCtx(({row:item}) => [
        _createVNode("button", {
          class: "action-btn",
          type: "button",
          onClick: ($event: any) => (_ctx.getScenario(item.exception, 'message.EXCEPTION'))
        }, [
          _hoisted_3
        ], 8, ["onClick"])
      ]),
      "cell-actions": _withCtx(({row:item}) => [
        _createVNode("button", {
          class: "action-btn",
          type: "button",
          onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
        }, [
          _hoisted_4,
          _createVNode("div", {
            class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
          }, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("a", {
                  onClick: ($event: any) => (_ctx.retryJob(item.uuid)),
                  class: "menu-link me-1"
                }, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("message.RETRY")), 1)
                ], 8, ["onClick"])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("a", {
                  onClick: ($event: any) => (_ctx.getScenario(item?.data, 'message.PAYLOAD')),
                  class: "menu-link me-1"
                }, [
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("message.PAYLOAD")), 1)
                ], 8, ["onClick"])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("a", {
                  onClick: ($event: any) => (_ctx.getScenario(item.exception, 'message.EXCEPTION')),
                  class: "menu-link me-1"
                }, [
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("message.EXCEPTION")), 1)
                ], 8, ["onClick"])
              ])
            ])
          ], 2)
        ], 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["columns", "rows", "loading"]),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode("h2", null, _toDisplayString(_ctx.$t(_ctx.popup_title)), 1),
              _hoisted_16
            ]),
            (_ctx.failed_scenarios)
              ? (_openBlock(), _createBlock("div", _hoisted_17, _toDisplayString(_ctx.failed_scenarios), 1))
              : (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(_ctx.$t("message.NO_DATA_FOUND")), 1))
          ])
        ])
      ])
    ])
  ]))
}